import styled from 'styled-components';
import tw, { classnames, flexWrap, position, borderColor, borderRadius, transitionTimingFunction, transitionDuration, width, backgroundColor, padding, textColor, textAlign, fontSize, borderWidth } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(borderWidth('border-1' as any), backgroundColor('bg-gray-50', 'dark:bg-gray-800' as any), textColor('text-gpas-700' as any, 'dark:text-white' as any), flexWrap('flex-wrap'), position('relative'), borderColor('dark:border-gray-700' as any), borderRadius('rounded-md'), transitionTimingFunction('ease-in'), transitionDuration('duration-300'), width('w-full', 'md:w-64', 'lg:w-64', 'xl:w-64'), padding('py-4', 'px-6'), textAlign('text-left'))
})``;

export const Header = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'), padding('pb-0'))
})``;

export const Content = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'), padding('pb-2'))
})``;

export const Paragraph = styled.p.attrs({
    className: classnames(textColor('text-gpas-700' as any, 'dark:text-white' as any), padding('pb-2'), fontSize('text-sm'))
})``;

export const ResourceContainer = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'))
})``;
